export default {
    heart_beat:0x270f, //心跳
    login_request:0x2328, //登录
    login_ack:0x2329,//登录应答
    logout_request:0x232b,//登出
    mutual_exclusion_login:0x232a,//互斥，被踢下线

    p2p_message_request:0x3e9, //发送p2p消息
    p2p_message_ack:0x3ea,//消息ack 1002
    p2p_message_receive_ack:0x3eb,//消息回执 1003
    p2p_message_has_read:0x3ec,//消息已读 1004

    group_message_request:0x835, //群聊消息收发
    group_message_ack:0x836, //群消息ack

    image_transfer_request:0x1389,//图片发送请求
    image_data:0x138a,//发送图片数据
    image_transfer_complete:0x138b, //发送图片数据完成
    image_transfer_complete_response:0x138c
    
}